import "./style.css";

export function CircleFocus() {
  return (
    <div className="circle_focus_div">
      <img className="circle_focus" src="./img/u15.svg" />
    </div>
  );
}
